import { connect } from 'react-redux';
import { clearUploadTypologies } from '../../../redux/actions/trm/trmDashboard';
import TypologyUploadDashboard from './TypologyUploadDashboard';

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    clearUploadTypologies: (payload) => {
      dispatch(clearUploadTypologies());
    }
  };
}

export default connect(null, mapDispatchToProps)(TypologyUploadDashboard);
